export default "__VITE_ASSET__CsD8Uy$9__"